import React from "react";
import {
	FormControlLabel as MuiFormControllLabel,
	Checkbox as MuiCheckbox,
} from "@mui/material";

function CheckboxBasic({
	nameSx, // object
	name = "Checkbox", // string
	disabled = false, // bool
	labelPlacement = "end", // 'bottom' | 'end'| 'start'| 'top'
	checked = false, // bool
	checkedIcon, // node
	classes, // object
	color = "primary", // 'default' | 'primary'| 'secondary'| 'error'| 'info'| 'success'| 'warning'
	defaultChecked = false, // bool
	disableRipple = false, // bool
	icon, // node
	id = "", // string
	indeterminate = false, // bool
	indeterminateIcon, // node
	inputProps, // object
	inputRef, // ref
	required = false, // bool
	size = "medium", // 'medium' | 'small'
	sx, // object
	value = "", // any
	onChange = (e) => {},
}) {
	const ChangeChecked = (e) => {
		onChange(e.target.checked);
	};

	return (
		<MuiFormControllLabel
			sx={nameSx}
			label={name}
			disabled={disabled}
			labelPlacement={labelPlacement}
			control={
				<MuiCheckbox
					checked={checked}
					checkedIcon={checkedIcon}
					classes={classes}
					color={color}
					// defaultChecked={defaultChecked}
					disableRipple={disableRipple}
					icon={icon}
					// id={id}
					indeterminate={indeterminate}
					indeterminateIcon={indeterminateIcon}
					inputProps={inputProps}
					inputRef={inputRef}
					required={required}
					size={size}
					sx={sx}
					value={value}
					onChange={ChangeChecked}
				/>
			}
		/>
	);
}

export default React.memo(CheckboxBasic);
